<div class="wrap">
  <form [formGroup]="registerForm" (ngSubmit)="checked? onSubmit() : conditonNotAccepted()">

    <div class="form-group">
      <label for="lastName">Nom</label>
      <input class="without_radio" type="text" formControlName="lastName" class="form-control"
        (input)="isInactive($event.target.value)" />
    </div>
    <div class="form-group">
      <label for="firstName">Prénom</label>
      <input class="without_radio" type="text" formControlName="firstName" class="form-control"
        (input)="isInactive($event.target.value)" />
    </div>
    <div class=" form-group">
      <label for="username">E-mail</label>
      <input class="without_radio" type="email" formControlName="email" class="form-control"
        (input)="isInactive($event.target.value)" />
    </div>

    <div class="form-group">
      <label for="password">Mot de passe</label>
      <input class="without_radio" type="password" formControlName="password" class="form-control"
        matTooltip="Minimum huit caractères, au moins une lettre majuscule, une lettre minuscule, un chiffre et un caractère spécial"
        (input)="isInactive($event.target.value)" />
    </div>
    <div class="form-group">
      <label for="password">Confirm. Mot de passe </label>
      <input class="without_radio" type="password" formControlName="confirmPassword" class="form-control"
        matTooltip="Minimum huit caractères, au moins une lettre majuscule, une lettre minuscule, un chiffre et un caractère spécial"
        (input)="isInactive($event.target.value)" />
    </div>

    <div class="conditions">
      <mat-checkbox class="check" (click)="isCheck()">J'accepte les conditions
        d'utilisation de le FFVoile. <a [routerLink]="['/conditions']" routerLinkActive="router-link-active">Plus d'info
          ici.</a>
      </mat-checkbox>
    </div>
    <div class="register">
      <button [disabled]="loading" [ngClass]="{inactive: !inactive}">
        Confirmer
      </button>
    </div>
  </form>
</div>